import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewChild, booleanAttribute, computed, inject, input, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { IconModule } from '@teamfoster/sdk/icon';
import {
  YoutubeChangeEvent,
  YoutubePlayerComponent,
  YoutubePlayerModule,
  YoutubePlayerVars,
  YoutubeReadyEvent,
  YoutubeState,
} from '@teamfoster/sdk/youtube-player';
import { YoutubeDialogComponent } from '../../dialogs/youtube-dialog/youtube-dialog.component';

@Component({
  selector: 'app-youtube',
  imports: [CommonModule, YoutubePlayerModule, IconModule],
  templateUrl: './youtube.component.html',
  styleUrl: './youtube.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YoutubeComponent {
  private _dlg = inject(MatDialog);

  url = input.required<string>();
  cookiePreferences = input<CookiePreferences>();
  title = input<string>();
  poster = input<string | null>();
  previewOnly = input<boolean>(false);
  color = input<'primary' | 'secondary' | 'accent'>('primary');

  inline = input<unknown, boolean>(false, { transform: booleanAttribute });
  previewOnHover = input<boolean>(false);

  loaded = output<boolean>();

  @ViewChild('youtube', { static: false }) youtubeComponent?: YoutubePlayerComponent;

  youtubeConfig = input<YoutubePlayerVars>({
    modestbranding: 1,
  });

  state: YoutubeState = -1;

  videoAltText$ = computed(() => {
    return this.title() || this.youtubeComponent?.player.videoTitle || 'Youtube video';
  });

  // if is mobile device
  isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  youtubePoster$ = computed(() => {
    if (this.poster()) {
      return this.poster();
    }
    const id = this.getVideoId(this.url());
    if (!id) {
      return;
    }

    return this.getThumbnailUrl(id);
  });

  getVideoId(url: string) {
    // Use a regular expression to extract the video ID from the URL
    const regExp =
      /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regExp);

    return match && match[1] ? match[1] : null;
  }

  getThumbnailUrl(videoId: string) {
    // Build the thumbnail URL with the chosen quality ("maxresdefault" in this case)
    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  }

  onPlayerReady(e: YoutubeReadyEvent) {
    this.loaded.emit(true);
  }
  onPlayerChange(e: YoutubeChangeEvent) {
    this.state = e.data as YoutubeState;
  }

  playVideo() {
    // trigger fullscreen youtube video
    //isMobile

    if (!this.inline()) {
      this._dlg.open(YoutubeDialogComponent, { data: { url: this.url() }, minWidth: '75vw' });
      return;
    }
    this.youtubeComponent?.player.playVideo();
  }

  previewVideo(enter: boolean) {
    //console.log(this.youtubeComponent);

    if (!this.youtubeComponent?.player) {
      return;
    }

    //if (enter) {
    //  this.youtubeComponent?.player?.playVideo();
    //} else {
    //  this.youtubeComponent?.player?.pauseVideo();
    //  this.youtubeComponent?.player?.seekTo(0);
    //  //this.youtubeComponent?.player
    //}
  }
}
